import InvestorPortalPageHeader from "./InvestorPortalPageHeader";

/** Consistent staff module page wrapper for Investment Hub admin screens */
export default function AdminModulePageShell({ title, subtitle, action, children, className = "" }) {
  return (
    <div className={`pb-4 ${className}`}>
      <InvestorPortalPageHeader title={title} subtitle={subtitle} action={action} />
      {children}
    </div>
  );
}
